import React from "react";
import { Button } from "@abb/abb-common-ux-react";
import { LABEL_DECIMALS } from '../../utilities/Constants';
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";

interface IProps {
    onAddPropertyClick: () => void;
}

export class ManualProperties extends React.Component<IProps> {
    public render() {
        return (
            <Translation>
                {
                    t =>
                        <div className="box-below-form h-10 h-100 mb-4" style={{ clear: "both" }}>
                            <div className="col-md-12 p-0">
                                <div className="box-circle">
                                    <p className="box-circle-text"> 3 </p>
                                </div>
                                <div className="ml-4">
                                    <p className="sidebar-main-title font-weight-bold ml-2">{t(CONSTANTS.LABEL_PROPERTIES)}</p>
                                </div>
                                <hr className="hr-line" />
                            </div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-md-12 no-padding mt-1">
                                    <div className="overflow-auto float-left width-class-manual no-padding mt-1"> 
                                        <div className="mt-2 p-4">
                                            <p className="sidebar-main-title font-weight-bold">{t(CONSTANTS.FROM_INSTRUMENT_TYPE)}</p>
                                            {/* Table Here */}
                                            <div className="table-responsive-sm">
                                            <table className="table tbl-edit">
                                                <thead>
                                                    <tr>
                                                        <td className="table-title id text-uppercase" style={{ width: "10%", background: "#f5f5f5" }}>{t(CONSTANTS.LABLE_ID)}{" "}
                                <span className="required_header">*</span> </td>
                                                        <td className="table-title name text-uppercase" style={{ width: "15%", background: "#f5f5f5" }}>{t(CONSTANTS.LABLE_NAME)}{" "}
                                <span className="required_header">*</span> </td>
                                                        <td className="table-title property-name text-uppercase" style={{ width: "10%", background: "#f5f5f5" }}>{t(CONSTANTS.LABEL_PROPERTYID)}{" "}
                                <span className="required_header">*</span> </td>
                                                        <td className="table-title property-name text-uppercase" style={{ width: "15%", background: "#f5f5f5" }}>{t(CONSTANTS.MENU_PROPERTY + " " + CONSTANTS.LABLE_NAME)}{" "}
                                <span className="required_header">*</span> </td>
                                                        <td className="table-title direction text-uppercase" style={{ width: "10%", background: "#f5f5f5" }}>{t(CONSTANTS.LABLE_INSTRUMENT_DIRECTIONS)}{" "}
                                <span className="required_header">*</span> </td>
                                                        <td className="table-title unit text-uppercase" style={{ width: "10%", background: "#f5f5f5" }}>{t(CONSTANTS.LABEL_UNIT)}</td>
                                                        <td className="table-title min text-uppercase" style={{ width: "10%", background: "#f5f5f5" }}>{t(LABEL_DECIMALS)}</td>
                                                        <td className="table-title min text-uppercase" style={{ width: "10%", background: "#f5f5f5" }}>{t(CONSTANTS.LABLE_MIN)}</td>
                                                        <td className="table-title max text-uppercase" style={{ width: "10%", background: "#f5f5f5" }}>{t(CONSTANTS.LABLE_MAX)}</td>
                                                        <td			
														style={{
														  width: "10%",
														  background: "#f5f5f5",
														}}
													  ></td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.children}
                                                </tbody>
                                            </table>
                                            </div>
                                            <Button type="primary-blue"
                                                shape="rounded"
                                                text={t(CONSTANTS.BUTTON_ADD_PROPERTY)}
                                                onClick={this.props.onAddPropertyClick} />
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                }
            </Translation>
        )
    }
}